import { render, staticRenderFns } from "./HVConsulting.vue?vue&type=template&id=319f2d1c&scoped=true&lang=pug"
import script from "./HVConsulting.vue?vue&type=script&lang=js"
export * from "./HVConsulting.vue?vue&type=script&lang=js"
import style0 from "./HVConsulting.vue?vue&type=style&index=0&id=319f2d1c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319f2d1c",
  null
  
)

export default component.exports